import { defineMessages } from 'react-intl';

export default defineMessages({
  variable: { defaultMessage: 'Variable' },
  stable: { defaultMessage: 'Stable' },
});
